module.exports = __webpack_public_path__ + "img/30.16fe5c94.jpg";